/** Mint a replacement a little before expiry so the TV never sits on a dead code. */
export const PAIRING_ROTATE_LEAD_MS = 10_000;

/**
 * Milliseconds until the TV should silently mint a new pairing session.
 * Prefers `expiresAt - lead`; if that is already past, falls through to expiry.
 * Already-expired sessions → 0 (rotate now).
 */
export function msUntilPairingRotate(
  expiresAt: string,
  nowMs: number = Date.now(),
  leadMs: number = PAIRING_ROTATE_LEAD_MS,
): number {
  const expiresMs = new Date(expiresAt).getTime();
  if (Number.isNaN(expiresMs)) return 0;
  if (expiresMs <= nowMs) return 0;

  const rotateAt = expiresMs - leadMs;
  if (rotateAt <= nowMs) return Math.max(0, expiresMs - nowMs);
  return rotateAt - nowMs;
}
